import React, { useEffect } from "react"; // UPDATED: Added useEffect
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { useTranslation } from "react-i18next"; // UPDATED: Added useTranslation

// Context Provider
import { CartProvider } from "./context/CartContext"; // Path to your CartContext.js

// Layout Components
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import ScrollToTop from "./components/ScrollToTop";

// Pages
import Home from "./pages/Home";
import About from "./pages/About";
import Services from "./pages/Services";
import Testimonials from "./pages/Testimonials";
import FAQ from "./pages/FAQ";
import Contact from "./pages/Contact";
import Checkout from "./pages/Checkout";
import PaymentSuccess from "./PaymentSuccess"; // Added for ICICI Gateway redirection return handling
import NanoHealSpray from "./pages/NanoHealSpray"; // Detailed Product Page for Nano Heal
import SepilSpray from "./pages/SepilSpray"; // New Detailed Product Page for Sepil

// Configurations
import "./i18n";
import "./App.css";

function App() {
  const { i18n } = useTranslation(); // UPDATED: Hook to watch language state

  // UPDATED: Automatically updates <html lang="..."> tag in index.html when language changes
  useEffect(() => {
    if (i18n.language) {
      document.documentElement.lang = i18n.language.split("-")[0];
    }
  }, [i18n.language]);

  return (
    /* CartProvider wraps the entire app so that any component 
        (Navbar, Services, or Checkout) can access the shared cart state.
    */
    <CartProvider>
      <Router>
        {/* ScrollToTop ensures the window resets to the top on every route change */}
        <ScrollToTop /> 
        
        <div className="app">
          <Navbar />
          
          <main className="main-content">
            <Routes>
              {/* Home Page */}
              <Route path="/" element={<Home />} />
              
              {/* About Page */}
              <Route path="/about" element={<About />} />
              
              {/* Products/Services - Multiple items can be added here */}
              <Route path="/products" element={<Services />} />
              <Route path="/services" element={<Services />} /> 
              
              {/* Detailed Product Pages */}
              <Route path="/products/nano-heal-spray" element={<NanoHealSpray />} />
              <Route path="/products/sepil-spray" element={<SepilSpray />} />
              
              {/* Merged Cart & Checkout Page */}
              <Route path="/checkout" element={<Checkout />} />
              
              {/* ICICI Orange PG Return Platform Landing Page */}
              <Route path="/payment-success" element={<PaymentSuccess />} />
              
              {/* Informational Pages */}
              <Route path="/testimonials" element={<Testimonials />} />
              <Route path="/faq" element={<FAQ />} />
              <Route path="/contact" element={<Contact />} />
            </Routes>
          </main>
          
          <Footer />
        </div>
      </Router>
    </CartProvider>
  );
}

export default App;